import React from "react";
import { withRouter, Link } from "react-router-dom";
import { Config } from "../../Config";
import logo from "../../assets/images/logo.png";
import "./LittleHeader.scss";
import "./Responsive.scss";

const LittleHeader = (props) => {
  return (
    <header>
      <div className="littleTopHeader mobile">
        <Link className="backBtnWrapper" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="32" viewBox="0 0 14 32" fill="none">
            <path
              d="M1.08597 31.3104C0.678735 30.7779 0.641714 29.9446 0.974903 29.3573L1.08597 29.1891L10.9802 16.2498L1.08597 3.31041C0.678735 2.77788 0.641714 1.94455 0.974903 1.35733L1.08597 1.18909C1.4932 0.656559 2.13045 0.608147 2.5795 1.04386L2.70815 1.18909L13.414 15.1891C13.8213 15.7216 13.8583 16.555 13.5251 17.1422L13.414 17.3104L2.70815 31.3104C2.2602 31.8962 1.53392 31.8962 1.08597 31.3104Z"
              fill="#1F3BCD"
            />
          </svg>
        </Link>
        <div className="headerLinks">
          <div className="headerlinksItem">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt={`IranRegalo | ${Config.helmetTitle}`} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default React.memo(withRouter(LittleHeader));
